import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { fileUrl } from "../../lib/api";

const NAV = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/programs", label: "Programs" },
    { to: "/gallery", label: "Gallery" },
    { to: "/news", label: "News & Stories" },
    { to: "/resources", label: "Resources" },
    { to: "/partners", label: "Partners" },
    { to: "/careers", label: "Careers" },
    { to: "/donate", label: "Donate" },
    { to: "/contact", label: "Contact" },
];

export const Header = () => {
    const { config } = useSiteConfig();
    const [open, setOpen] = useState(false);

    return (
        <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/80 border-b border-border" data-testid="site-header">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
                    {config?.logo_url ? (
                        <img src={fileUrl(config.logo_url)} alt={config.site_name} className="h-14 w-14 object-contain" data-testid="site-logo" />
                    ) : (
                        <div className="h-10 w-10 rounded-sm flex items-center justify-center bg-primary text-primary-foreground font-display text-xl tracking-tight">
                            Y
                        </div>
                    )}
                    <div className="flex flex-col leading-none">
                        <span className="font-display text-xl font-semibold tracking-tight text-foreground">
                            {config?.site_name || "YACRRD"}
                        </span>
                        <span className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground mt-1 hidden sm:block">
                            {config?.tagline ? config.tagline.slice(0, 40) : "South Sudan"}
                        </span>
                    </div>
                </Link>

                <nav className="hidden lg:flex items-center gap-1" data-testid="primary-nav">
                    {NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.to === "/"}
                            className={({ isActive }) =>
                                `px-4 py-2 text-sm rounded-sm transition-colors ${
                                    isActive
                                        ? "text-primary font-medium"
                                        : "text-foreground/80 hover:text-primary"
                                }`
                            }
                            data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-3">
                    <Link
                        to="/donate"
                        className="inline-flex items-center px-4 py-2.5 rounded-sm border border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground transition-colors text-sm font-medium"
                        data-testid="header-cta-donate"
                    >
                        Donate
                    </Link>
                    <Link
                        to="/contact"
                        className="inline-flex items-center px-5 py-2.5 rounded-sm border border-primary bg-primary text-primary-foreground hover:bg-primary/90 transition-colors text-sm font-medium"
                        data-testid="header-cta-partner"
                    >
                        Partner With Us
                    </Link>
                </div>

                <button
                    className="lg:hidden p-2 rounded-sm border border-border"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle menu"
                    data-testid="mobile-menu-toggle"
                >
                    {open ? <X size={20} /> : <Menu size={20} />}
                </button>
            </div>

            {open && (
                <div className="lg:hidden border-t border-border bg-background" data-testid="mobile-nav">
                    <nav className="flex flex-col px-6 py-4 gap-1">
                        {NAV.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end={item.to === "/"}
                                onClick={() => setOpen(false)}
                                className={({ isActive }) =>
                                    `px-3 py-3 rounded-sm text-sm ${isActive ? "text-primary font-medium" : "text-foreground/80"}`
                                }
                            >
                                {item.label}
                            </NavLink>
                        ))}
                        <Link
                            to="/contact"
                            onClick={() => setOpen(false)}
                            className="mt-2 inline-flex items-center justify-center px-5 py-3 rounded-sm bg-primary text-primary-foreground text-sm font-medium"
                        >
                            Partner With Us
                        </Link>
                    </nav>
                </div>
            )}
        </header>
    );
};

export default Header;
